import React from 'react';
import MagicLinkPassword from 'components/MagicLinkPassword';
import Header from 'components/MagicLinkPassword/Header';

const MagicLinkPasswordPage = props => {
  return (
    <>
      <Header />
      <MagicLinkPassword {...props} />
    </>
  );
};

export default MagicLinkPasswordPage;
